import { Flex, Spinner } from "@chakra-ui/react";
import JGoogleIcon from "../JGoogleIcon/JGoogleIcon";
import Team from "./components/Team";
import GroupMenus from "./components/GroupMenus";
import useSidebarV2 from "./useSidebarV2";
import sidebarV2Store from "../../stores/sidebar-v2.store";
import menuPrivilegeStore from "../../stores/menu-privilege.store";
import SearchbarWrapper from "./components/SearchbarWrapper";
import Menu from "./components/Menu";

export default function SidebarV2() {
  const { backgroundColor, textColor, betaMenu } = useSidebarV2()
  const { reveal, setReveal, showMobile } = sidebarV2Store()
  const { loading } = menuPrivilegeStore()

  return (
    <Flex 
      position={{ base: 'absolute', md: 'static' }}
      left={showMobile ? '0px' : '-100%'}
      top='56px'
      bottom='0px'
      zIndex={999}
      direction='column' 
      width={reveal ? '248px' : '80px'} 
      padding='16px'
      background={backgroundColor}
      transition='0.3s'
      height='calc(100vh - 56px)'
    >
      {/* Icon humberger */}
      <JGoogleIcon
        name={reveal ? 'menu_open' : 'menu'}
        fontSize='24px'
        color={textColor}
        cursor='pointer'
        onClick={() => setReveal(!reveal)}
      />

      {/* Team name */}
      <Team />

      {/* Searchbar */}
      <SearchbarWrapper />

      {/* Beta version menu */}
      <Flex direction='column' marginTop='12px'>
        <Menu standaloneMenu={betaMenu} />
      </Flex>

      {/* Group menu */}
      {loading
        ? <Spinner color={textColor} marginTop='12px' />
        : <GroupMenus />
      }
    </Flex>
  )
}
